import React, { Children, cloneElement } from 'react';
import { string, bool } from 'prop-types';
import cx from 'classnames';

import ModalPortal from './ModalPortal';
import ModalStatic from './Modal.static';

const CLASS_ROOT = 'modal';

export default class Modal extends React.Component {
  static displayName = 'Modal';

  static propTypes = {
    id: string.isRequired,
    disablePortal: bool,
  };

  static defaultProps = {};

  state = {};

  componentDidMount() {
    this.modal = new ModalStatic(this.modalRef, { moveModalToBottom: false });
  }

  componentWillUnmount() {
    this.modal.destroy();
  }

  renderChildren() {
    const { children, id } = this.props;

    return Children.map(children, child => {
      if (child.type) {
        // react element
        return cloneElement(child, {
          'aria-labelledby': id,
          className: `${CLASS_ROOT}__content`,
        });
      }
      return child;
    });
  }

  render() {
    const { className, children, disablePortal, id, ...other } = this.props;

    const classes = cx(CLASS_ROOT, className);

    return (
      <ModalPortal disabled={disablePortal}>
        <div
          id={id}
          aria-hidden="true"
          data-modal=""
          className={classes}
          ref={ref => {
            this.modalRef = ref;
          }}
          {...other}
        >
          <div
            className={`${CLASS_ROOT}__overlay`}
            tabIndex="-1"
            data-a11y-dialog-hide=""
          />
          {this.renderChildren()}
        </div>
      </ModalPortal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Modal/Modal.js